export function balanceText(string: string) {
  const spaceCount = (string.match(/ /g) || []).length

  if (spaceCount >= 3) {
    return string.replace(/(.*)(\s)(.*)/, '$1\u00A0$3')
  } else {
    return string
  }
}
